/* eslint-disable no-var */
require('slick-carousel');
// require('sticky-kit/dist/sticky-kit.min.js');
require('magnific-popup');

var WebFont =  require('webfontloader');


WebFont.load({
  google: {
    families: [
      'Barlow:200,300,400,500,600,700',
      'Heebo:400,700',
      'Kristi:200,300,400,500,600,700',
      'Khand:200,300,400,500,600,700'
    ],
  },
});
function initMap() {

    var markerIcon = '';
    let lat = 0;
    let lng = 0;
    if(jQuery('body').hasClass('home-page')){
        markerIcon = jQuery('.location .active').data('marker');
        lat = parseFloat(jQuery('.location .active').data('lat'));
        lng = parseFloat(jQuery('.location .active').data('lng'));
    } else {
        markerIcon = jQuery('.tabs-location  .active.tab-nav').data('marker');
        lat = parseFloat(jQuery('.tabs-location  .active.tab-nav').data('lat'));
        lng = parseFloat(jQuery('.tabs-location  .active.tab-nav').data('lng'));
    }

    let uluru = {lat: lat, lng:lng};
    let map = new google.maps.Map(document.getElementById('map'), {
        zoom: 18,
        center: uluru
    });

    let marker = new google.maps.Marker({
        position: uluru,
        map: map,
        animation: google.maps.Animation.DROP,
        icon: {
            url: markerIcon,
            scaledSize: new google.maps.Size(180, 180)
        }
    });
}
jQuery(document).ready( function ($){

  const openbtn = document.getElementById('open-button');
  let isOpen = false;

  function toggleMenu() {
    if (isOpen) {
      $('body').removeClass('show-menu');
    } else {
      $('body').addClass('show-menu');
    }
    isOpen = !isOpen;
  }

  $('#open-button').on('click', toggleMenu);
  $('#close-button').on('click', toggleMenu);
  // $('.content-wrap').on('click', function({ target }){
  //   if (isOpen && target !== openbtn) {
  //     toggleMenu();
  //   }
  // });

  // mobile menu expand/minimize
  const $hasChildrenItem = $('.menu-wrap .menu-item-has-children');
  $hasChildrenItem.prepend('<div class="expand-btn"></div>');
  $('.expand-btn').click(function(event) {
    const $menuItem = $(event.currentTarget).parent();
    const $parentItem = $(event.currentTarget).parent().parent();

    if ($menuItem.hasClass('open')) {
      $parentItem.find('.menu-item-has-children').removeClass('open');
    } else {
      $parentItem.find('.menu-item-has-children').removeClass('open');
      $menuItem.addClass('open');
    }
  });

  const sticky = $('#sticky-header');
  const stickyHeaderTop = 1;
  $(document).on('scroll', function() {
    if ($(window).scrollTop() > stickyHeaderTop) {
      sticky.addClass('fixed').removeClass('unfixed');
    } else {
      sticky.removeClass('fixed').addClass('unfixed');
    }
  });
  // slick hero home
  if ($('.slick-hero-home .item').length > 1) {
      $('.slick-hero-home .wrap').slick({
          slidesToShow: 1,
          adaptiveHeight: false,
          dots: true,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 2000,
          infinite: true,
          centerMode: false,
          variableWidth: false,
          responsive: [
              {
                  breakpoint: 767,
                  settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      infinite: true
                  }
              },


          ]
      });
  };
    if ($('.popul-packages-slick .item').length > 1) {
        $('.popul-packages-slick .wrap').slick({
            slidesToShow: 4,
            adaptiveHeight: false,
            dots: false,
            arrows: true,
            infinite: true,
            centerMode: true,
            variableWidth: true,
            autoplay: true,
            autoplaySpeed: 2000,
            centerPadding: '60px',
            initialSlide: 0,
            prevArrow: $('.popul-packages .slick-template-prev'),
            nextArrow: $('.popul-packages .slick-template-next'),
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                        variableWidth: false,
                        centerMode: false,
                        centerPadding: '15px',
                    }
                },
                {
                    breakpoint: 450,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        variableWidth: false,
                        centerMode: false,
                        centerPadding: '15px',
                    }
                },
            ]
        });
    };
  $(document).on('click','.tab-nav',function (e) {
      e.preventDefault();
      let $el = $(this);
      let dataTab = $el.data('tab');
      $el.closest('.tab-wrapper').find('.tab-nav').removeClass('active')
      $el.addClass('active')
          .closest('.tab-wrapper').find('.tab-item[data-tab="'+dataTab+'"]').addClass('active').siblings().removeClass('active');
  });

  $(document).on('click','.locations .tab-nav',function (e) {
      e.preventDefault();
      $('#location-img').attr('src',$(this).data('img'));
      $('#location-title').html($(this).data('title'));
      let uluru = {lat: $(this).data('lat'), lng: $(this).data('lng')};
      let map = new google.maps.Map(document.getElementById('map'), {
          zoom: 18,
          center: uluru
      });
      let marker = new google.maps.Marker({
          position: uluru,
          map: map,
          animation: google.maps.Animation.DROP,
          icon: {
              url: $(this).data('marker'),
              scaledSize: new google.maps.Size(180, 180)
          }
      });
  });

    $(document).on('click','.location li a',function(){
        $('.location li').removeClass('active');
        $(this).closest('li').addClass('active');
        let uluru = {lat: $(this).parent().data('lat'), lng: $(this).parent().data('lng')};
        let map = new google.maps.Map(document.getElementById('map'), {
            zoom: 18,
            center: uluru
        });
        let marker = new google.maps.Marker({
            position: uluru,
            map: map,
            animation: google.maps.Animation.DROP,
            icon: {
                url: $(this).parent().data('marker'),
                scaledSize: new google.maps.Size(180, 180)
            }
        });
    });
    $('.popup-with-video').magnificPopup({
        preloader: true,
        type: 'iframe',
        mainClass: 'mfp-fade'
    });

    $('.gfield input:not([type="checkbox"]):not([type="radio"]):not([type="file"]), .gfield textarea, .gfield select').on('checkval', function(event, param) {
        checkvalFunction (this, event, param);
    }).on('keyup input paste', function() {
        $(this).trigger('checkval', 'focus');
        console.log('2')
    }).on('blur', function() {
        $(this).trigger('checkval');
        console.log('3')
    }).focus(function() {
        $(this).trigger('checkval', 'focus');
        console.log('4')
    }).trigger('checkval');



  // smooth scroll
  // $('a[href*="#"]')
  //   .not('[href="#"]')
  //   .not('[href="#0"]')
  //   .not('[href="#applying-form"]')
  //   .click(function(event) {
  //     if (
  //       location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
  //       &&
  //       location.hostname == this.hostname
  //     ) {
  //       event.preventDefault;
  //       var target = $(this.hash);
  //       var top = target.offset().top;
  //       if ($(window).width() > 992) {
  //         top = top - 119;
  //       };
  //       target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
  //       if (target.length) {
  //         event.preventDefault();
  //         $('html,body').animate({
  //           scrollTop: top
  //         }, 1000);
  //       }
  //     }
  //   });

  //rating
  $('.rating').each(function(i, item)  {
    var rating = $(item).data('rating');
    var starWidth = $(item).data('star-width');
    var starSpacing = $(item).data('star-spacing');
    $(item).find('.filling-stars').css('width', (rating * starWidth) + (parseInt(rating) * starSpacing) + 'px');
  });

  function checkvalFunction (obj, event, param) {
    var label = $(obj).parent().prev('label');
    if(obj.value !== '' || param == 'focus') {
      label.addClass('show');
    } else {
      label.removeClass('show');
    }
  }

  //form labels
  $('.gfield input:not([type="checkbox"]):not([type="radio"]):not([type="file"]), .gfield textarea').on('checkval', function(event, param) {
    checkvalFunction (this, event, param);
  }).on('keyup input paste', function() {
    $(this).trigger('checkval', 'focus');
  }).on('blur', function() {
    $(this).trigger('checkval');
  }).focus(function() {
    $(this).trigger('checkval', 'focus');
  }).trigger('checkval');

  jQuery(document).on('.gform_post_render', function() {
    //confirmation form class
    setTimeout(function () {
      $('.gform_confirmation_wrapper').closest('.footer-form-wrap').addClass('confirmation');
      //form labels
      $('.gfield input:not([type="checkbox"]):not([type="radio"]):not([type="file"]), .gfield textarea').on('checkval', function(event, param) {
        checkvalFunction (this, event, param);
      }).on('keyup input paste', function() {
        $(this).trigger('checkval', 'focus');
      }).on('blur', function() {
        $(this).trigger('checkval');
      }).focus(function() {
        $(this).trigger('checkval', 'focus');
      }).trigger('checkval');
    }, 100);
  });

  //process section items hover
  $('.process .item').hover(function (event) {
    $(event.currentTarget).nextAll().removeClass('hover')
    $(event.currentTarget).prevAll().addClass('hover');
  });

  //opening external links in new tab
  $(document.links).filter(function() {
    return this.hostname != window.location.hostname;
  }).attr({
    'target': '_blank',
    'rel': 'noopener'
  });

  //add class to footer
  $('.cta-block').closest('.skills:last-child').closest('.main').siblings('.footer').addClass('after-cta-block');

  //portfolio filter
  $('.portfolio-nav li').click( function(event) {
    $(event.currentTarget).siblings('li').removeClass('active');
    $(event.currentTarget).addClass('active');
    var filterClass = $(event.currentTarget).data('filter');
    $('.portfolio .wrap .item').hide();
    $('.portfolio .wrap .item.' + filterClass).show();
  });




  //single project page sticky content
  const stickRightPart = function () {
    if ($(window).width() >= 993) {

      if ($('.page-top-section .right .text').length) {
        const stickElement = $('.page-top-section .right .text');
        let stopElement = $('.main > section:last-child, .main > div:last-child');
        if (stopElement.hasClass('popup')) {
          stopElement = stopElement.prev();
        }
        var stopTop = stopElement.offset().top - 430;

        $(window).scroll(function () {
          var currentScroll = $(window).scrollTop();
          if (currentScroll > stopTop) {
            var delta = currentScroll - stopTop;
            stickElement.css('marginTop', '-' + delta + 'px');
          } else {
            stickElement.css('marginTop', 0);
          }
        });
      }
    } else {
      $('.page-top-section .right').trigger('sticky_kit:detach');
    }
  };



  $('.our-expertise .wrap').slick({
    adaptiveHeight: false,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 6000,
    infinite: true,
    variableWidth: true,
  });


  //middle-block-function
  var middleSection = function ($elem) {
    $elem.each( function(i, item)  {
      var height = $(item).outerHeight();
      $(item).css('margin-top', height / 2 * -1 + 'px');

      if ($(item).next().length <= 0) {
        if ($(item).find('.prefooter').length < 1) {
          $(item).append('<div class="prefooter" style="padding-top: ' + height / 2 + 'px;"></div>');
          $(item).find('.prefooter').css('margin-top', height / 2 * -1 + 'px');
        } else {
          $(item).find('.prefooter').css('padding-top', height / 2 + 'px').css('margin-top', height / 2 * -1 + 'px');
        };
      } else {
        if ($(item).next().find('.additional-padding-top').length < 1) {
          $(item).next().css('margin-top', height / 2 * -1 + 'px').prepend('<div class="additional-padding-top" style="padding-top:' + height / 2 + 'px;"></div>');
        } else {
          $(item).next().css('margin-top', height / 2 * -1 + 'px').find('.additional-padding-top').css('padding-top', height / 2 + 'px');
        };
      };

      if ($(item).prev().find('.additional-padding-bottom').length < 1) {
        $(item).prev().append('<div class="additional-padding-bottom" style="padding-bottom: ' + height / 2 + 'px;"></div>');
      } else {
        $(item).prev().find('.additional-padding-bottom').css('padding-bottom', height / 2 + 'px');
      };
    });
  };

  $(window).resize( function()  {
    middleSection($('.cta-block'));
  });

  $(window).trigger('resize');


  $('.popup-btn').magnificPopup({
    type: 'inline',
    preloader: false,
  });

  var bannerSliderSpeed = ($('.banner-slider .wrap').data('autoplay-speed')) ? $('.banner-slider .wrap').data('autoplay-speed') : 6000;
  $('.banner-slider .wrap').slick({
    adaptiveHeight: false,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: bannerSliderSpeed,
    infinite: true,
    slidesToShow: 2,
    variableWidth: true,
    rtl: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerMode: true,
          variableWidth: false,
        }
      },
      {
        breakpoint: 567,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          variableWidth: true,
        }
      },
    ]
  });

  //chat and recaptcha position
  function chatAndRecaptchaPosition() {
    if (!$('html').hasClass('has-cookie-bar cookie-bar-bottom-bar')) {
      return;
    };
    var height = parseInt($('#catapult-cookie-bar').outerHeight());
    var styles = '<style>.has-cookie-bar.cookie-bar-bottom-bar body > .container {margin-bottom:' + height + 'px;} .has-cookie-bar.cookie-bar-bottom-bar .mcwidget-embed {bottom:' + parseInt(height - 30) + 'px;} .has-cookie-bar.cookie-bar-bottom-bar .grecaptcha-badge {bottom:' + parseInt(height + 1) + 'px !important;}</style>';
    $('#additional-styles').html(styles);
  }

  $('body').append('<div id="additional-styles"></div>');

  $(window).load(function () {
    chatAndRecaptchaPosition();
  });

  $(window).resize(function () {
    chatAndRecaptchaPosition();
  });
    initMap();
});


global.initMap = function()  {
  jQuery('.map-canvas').each(function(index, element) {
    let map = jQuery(element);
    const position = new google.maps.LatLng(map.data('latitude'), map.data('longitude'));
    const markerIcon = map.data('icon') || '';
    const mapZoom = map.data('zoom');

    map = new google.maps.Map(element, {
      zoom: mapZoom || 17,
      center: position,
      disableDefaultUI: true,
    });

    new google.maps.Marker({
      position: position,
      map: map,
      icon: markerIcon || '',
    });

  });
};



// WEBPACK FOOTER //
// ./src/assets/js/init.js